export const findTouchedField = (formData, dirty) => {
  let returnedData;

  if (dirty) {
    for (let item in formData) {
      if (formData[item]) {
        returnedData = { item };
      }
    }
    return returnedData;
  }
};
